import ROUTERS from '../../config/routes';

export const openLink = link => {
  if (!link) {
    return;
  }
  window.open(link, '_blank');
};
